/* eslint-disable max-len */
import * as utils from '../styleUtils';
import { SLF_SEL, DEFAULT_SETTINGS } from '../constants';

const { makeASlightlyDifferentColor } = utils;
const { general: { backgroundColor: defaultBgColor } } = DEFAULT_SETTINGS;

/**
 * @description Create css styles for Background Color
 * @param designSettings
 * @return {string}
 */
export default function (designSettings = {}) {
    const generalDesignSettings = designSettings.general || {};
    const bgColor = generalDesignSettings.backgroundColor;
    if (!bgColor) {
        return '';
    }
    const bgSecondaryColor = makeASlightlyDifferentColor(bgColor, 0.05);
    const bgHoverColor = makeASlightlyDifferentColor(bgColor, 0.1);
    const bgSecondaryOrDefault = bgColor === defaultBgColor ? bgColor : bgSecondaryColor;
    return {
        [SLF_SEL.BACK]: { backgroundColor: bgColor },
        [SLF_SEL.BACK_HOV]: {
            backgroundColor: bgColor,
            '&:hover': { backgroundColor: bgHoverColor },
        },
        [SLF_SEL.BACK_HOV_LIGHT]: {
            backgroundColor: bgColor,
            '&:hover': { backgroundColor: bgSecondaryColor },
        },
        [SLF_SEL.BACK_SECONDARY]: { backgroundColor: bgSecondaryColor },
        [SLF_SEL.BACK_SECONDARY_OR_DEFAULT]: { backgroundColor: bgSecondaryOrDefault },
        [SLF_SEL.BACK_SECONDARY_HOV]: {
            backgroundColor: bgSecondaryColor,
            '&:hover': { backgroundColor: bgHoverColor },
        },
        '.sis-scope input, .sis-scope textarea': {
            backgroundColor: 'transparent',
        },
        textarea: {
            backgroundColor: 'transparent',
        },
        input: {
            backgroundColor: 'transparent',
        },
        '': {
            background: bgColor,
        },
    };
}
